import { Box } from '@mui/material';
import { CollectorContext, SpacerLayoutItem } from './SpacerLayout';

export const ScrollableSpacerLayoutArea = ({ children }) => {
  return (
    <SpacerLayoutItem>
      <CollectorContext.Provider value={{ reportLeaf: null }}>
        <Box
          sx={{
            height: '100%',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            flex: 1,
            minHeight: 0,
          }}
        >
          {children}
        </Box>
      </CollectorContext.Provider>
    </SpacerLayoutItem>
  );
};
